var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDollarSign = function SvgDollarSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 12,
    x: 7.2,
    y: 2.4,
    fill: "currentColor",
    rx: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.763 13.146a5.8 5.8 0 0 1-1.843-.288q-.864-.307-1.402-.864A1.85 1.85 0 0 1 4 10.688q0-.921 1.114-.998.192 1.075.902 1.593.729.5 1.843.5 1.115 0 1.728-.327.615-.326.615-.998 0-.48-.25-.768-.25-.308-.806-.519-.538-.23-1.556-.441-1.266-.288-2.016-.615-.748-.325-1.152-.864-.384-.537-.384-1.42 0-.75.461-1.345.461-.615 1.267-.94Q6.592 3.2 7.63 3.2q.96 0 1.805.269.864.268 1.382.768.538.5.538 1.152a.86.86 0 0 1-.346.71q-.345.25-.96.288-.057-.845-.691-1.325-.615-.498-1.728-.499-.922 0-1.46.346-.537.345-.537.921 0 .615.5.922.518.288 1.746.557 2.016.403 2.957 1.113.96.691.96 1.978 0 1.306-1.056 2.035-1.056.71-2.976.71"
  })));
};
export default SvgDollarSign;